import React, { useEffect, useRef ,useContext} from "react";
import { NavLink, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useRouteMatch } from "utils/useRouteMatchCompat";
import styles from "./SettingsPage.module.css";
import {
  prefetchSettingsSiblingRoutes,
  SettingsNewNavList,
} from "./NavigationList";
import {UserDetailsContext} from "../../../App";
import SearchableDropdown from "./SearchableDropdown";
import SideNavBar from "common-ui-components/components/side-nav-bar/SideNavBar";
import { filterPermittedNavList } from "app/root/FeatureHider";
import Error404 from "app/Error404";
import { useModuleAlerts } from "message-framework/hooks/useModuleAlerts";
import NewFeature from "common-ui-components/components/NewFeature";

const SettingsPage = () => {
  const { path } = useRouteMatch();
  const location = useLocation();
  const userDetails = useContext(UserDetailsContext);   // ← add here
  //console.log(userDetails?.roleName);
  const isSuperAdmin=userDetails?.roleName==="Super Admin";
  //console.log(isSuperAdmin);
  const lastPrefetchedPathRef = useRef(null);

  const rawPermittedNavlist = filterPermittedNavList(
      SettingsNewNavList,
      "SETTINGS",
  );

  const permittedNavlist = rawPermittedNavlist
      .map((group) => ({
        ...group,
        items: group.items?.filter(
            (item) => item.key !== "SAML_AUTHENTICATION" || isSuperAdmin,
        ),
      }))
      .filter((group) => group.items && group.items.length > 0);
  const permittedRoutesList = permittedNavlist.flatMap((group) =>
    (group.items || []).flatMap((item) => [...(item.subPages || []), item]),
  );
  const { messages } = useModuleAlerts(permittedRoutesList);

  useEffect(() => {
    if (lastPrefetchedPathRef.current === location.pathname) return;

    lastPrefetchedPathRef.current = location.pathname;
    prefetchSettingsSiblingRoutes(permittedNavlist, location.pathname);
  }, [location.pathname, permittedNavlist]);

  const InitialSettingsPage = ({ path }) => {
    return (
      <div className={styles.settingsContainer}>
        <div className={styles.settingsHome}>
          <div className={styles.topContainer}>
            <div className={styles.search}>
              <SearchableDropdown navList={permittedNavlist} />
            </div>
            <div
              className={`${styles.settingsMenu} ${
                permittedNavlist.length <= 5 ? styles.settingsMenuThreeColumns : ""
              }`}
            >
              {permittedNavlist.map((element) => (
                <DisplayGroup group={element} path={path} key={element.label} />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const DisplayGroup = ({ group }) => {
    return (
      <div className={styles.groupTopLevel}>
        <div className={styles.group}>
          <div 
          style={{ display: "flex", gap: "5px",marginBottom:"15px" }}
          >
            <img
              // style={{ marginTop: "25px" }}
              height={20}
              width={20}
              src={group.icon}
              alt={group.label}
            />
            <h2 className={styles.groupTitle}>{group.label}</h2>
          </div>
          <ul className={styles.navList}>
            {group.items.map((element) => (
              <NavLink
                key={element.label}
                className={styles.listItem}
                to={element.url}
              >
                <div style={{display:"flex", gap:"20px"}}>
                  <li>{element.extendedTitle || element.label}</li>
                  {element.newFeature && <NewFeature />}
                </div>
              </NavLink>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.settingsPage}>
      <Routes>
        <Route path="organization" element={<Navigate to="/app/settings" replace />} />
        <Route path="account" element={<Navigate to="/app/settings" replace />} />
        <Route path="security" element={<Navigate to="/app/settings" replace />} />
        <Route path="enrollment" element={<Navigate to="/app/settings" replace />} />
        <Route path="inventory" element={<Navigate to="/app/settings" replace />} />
        <Route path="remote" element={<Navigate to="/app/settings" replace />} />

        <Route index element={<InitialSettingsPage index />} />

        <Route path="*" element={
          <SideNavBar navList={permittedNavlist} width={"200px"} messages={messages}>
            <div className="RightPanel">
              <Routes>
                {permittedNavlist.map((element) => {
                  return element.items?.map(({ url, path: subPath, component, label }) => (
                    <Route path={(subPath || url).replace('/app/settings/', '')} key={url} element={component || label} />
                  ));
                })}
                <Route path="*" element={<Error404 />} />
              </Routes>
            </div>
          </SideNavBar>
        } />
      </Routes>
    </div>
  );
};

export default SettingsPage;

export const getCurrentlyRederedSettingsSubModule = () => {
  const rawPath = window.location.pathname;
  const resultPath = `/${rawPath.split("/").slice(2).join("/")}`;
  for (const group of SettingsNewNavList) {
    for (const item of group.items || []) {
      if (resultPath.startsWith(item.url)) return item.key;
    }
  }
  return "UNKNOWN";
};

export const getProductBySettingsSubModuleKey = (key) => {
  for (const group of SettingsNewNavList) {
    for (const item of group.items) {
      if (item.key === key) return item.product;
    }
  }
  return null;
};
